export const ErrorSenderToken = Symbol('ErrorSender');
export const PresenceRepositoryToken = Symbol('PresenceRepository');
